import { ArrowUpRight, SquareTerminal } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { APP_URL } from "@/components/SiteNav";

const BTN = "cta glass group inline-flex w-full sm:w-auto items-center justify-center gap-4 rounded-full border px-8 sm:px-12 py-5 sm:py-7 text-sm sm:text-lg font-bold tracking-[0.18em] uppercase";

export const CvBuilderCta = ({ onOpenSim }) => (
  <section className="relative px-6 min-h-[80vh] flex items-center justify-center py-24" data-testid="cv-builder-section">
    <Reveal className="text-center w-full">
      <p className="font-extrabold tracking-[-0.045em] leading-[1] text-4xl sm:text-6xl lg:text-7xl" data-testid="cv-builder-lead">
        Entra nell'infrastruttura.
      </p>
      <div className="mt-14 flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-5 max-w-sm sm:max-w-none mx-auto">
        <a href={APP_URL} target="_blank" rel="noopener noreferrer" className={`${BTN} cta-mega text-white`} data-testid="cv-builder-cta">
          Accedi al CV Builder
          <ArrowUpRight className="h-5 w-5 text-cyan transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-1" />
        </a>
        <button type="button" onClick={onOpenSim} aria-haspopup="dialog" className={`${BTN} cta-ghost text-white/80`} data-testid="cv-builder-sim-btn">
          <SquareTerminal className="h-5 w-5 text-cyan" strokeWidth={1.75} />
          Prova il simulatore
        </button>
      </div>
    </Reveal>
  </section>
);
